import React, { useState, useEffect } from 'react'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { useAuth } from 'Hooks'
import Loading from 'Components/loading'
import Config from 'Config'
import { MsalProvider } from '@azure/msal-react'
import { msalConfig } from 'Utils/msal'
import { PublicClientApplication } from '@azure/msal-browser'
import Approutes from './Routes'

const msalInstance = new PublicClientApplication(msalConfig)

function App() {
  const { isLoading } = useAuth()
  const [msalReady, setMsalReady] = useState(false)

  useEffect(() => {
    msalInstance.initialize().then(() => setMsalReady(true))
  }, [])

  if (!msalReady) {
    return <Loading />
  }

  return isLoading ? (
    <Loading />
  ) : (
    <GoogleOAuthProvider clientId={Config.GIS.clientId}>
      <MsalProvider instance={msalInstance}>
        <Approutes />
      </MsalProvider>
    </GoogleOAuthProvider>
  )
}

export default App
